import React from 'react';
import wb0 from '../img/Detail/sketches-detail.jpg';
import './Detail.css';
const SketchesDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Sketches and ongoing projects" />
    </div>

  );
};

export default SketchesDetail;
